export default __webpack_public_path__ + "static/media/ryan-basc.3f59e4e5.jpg";